module.exports = __webpack_public_path__ + "img/episode4.8eb74411.png";